import {Component, Input, OnInit} from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})

export class ActionButtonComponent implements OnInit {
  @Input() submitLabel: string;
  @Input() cancelLabel: string;
  @Input() showOnlySubmit = false;
  @Input() showOnlyCancel = false;

  constructor( private location: Location) { }

  ngOnInit() { }

  backPage(): void {
    this.location.back();
  }

}
